import { render } from "./Promotions.vue?vue&type=template&id=1192ba88&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=1192ba88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1192ba88"

export default script